module.exports = __webpack_public_path__ + "static/media/DSC04783.65a36fbe.JPG";